import React, { useEffect, useState } from "react";
import { getUserInfo, IbanUserPostApi } from "../../Api/BarestServices";
import { errorToast, succToast } from "../../Toast/Toast";
import BurgerMenuTitle from "../BurgerMenuTitle/BurgerMenuTitle";
import Style from "./Iban.module.css";
const Iban = () => {
  const [info, setInfo] = useState();
  const [iban, setIban] = useState();
  const [disable, setDisable] = useState(false);
  useEffect(() => {
    UserInfo();
  }, []);

  const sendShaba = () => {
    setDisable(true)
    const data = {
      iban: iban,
    };
    IbanUserPostApi(data, (res) => {
      if(res.status===1){
        setDisable(false)
        succToast(res.message)
      }else{
        setDisable(false)
        errorToast(res.message)
      }
    });
  };
  const UserInfo = async () => {
    getUserInfo((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setInfo(res.info)
        }
      }else{
        console.error(res)
      }
    })
  };
  return (
    <div className={Style.componentHolder}>
      <BurgerMenuTitle title={"شماره شبا"} />
      <div className={Style.centerHolder}>
        <div className={Style.bankPic}>
          <img src="/Assets/Images/Bank/iban.jpg" alt="شماره شبا" />
        </div>
        <label>شماره شبا</label>
        <input
          defaultValue={info&&info.iban}
          className={Style.shabaInput}
          type={"text"}
          onChange={(e) => setIban(e.target.value)}
        />
        <p className={Style.point}><span style={{color:"red"}}>*</span>حتما باید نام شما در سایت، با نام صاحب حساب یکسان باشد </p>
        <button className={Style.Btn} disabled={disable} onClick={sendShaba}>
          ثبت
        </button>
      </div>
    </div>
  );
};

export default Iban;
